var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',[_c('v-list',[_vm._l((_vm.locaisColeta),function(local,index){return [_c('v-list-item',{key:local.id},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(local.estado.nome)+" ")])],1)],1),(index !== (_vm.locaisColeta.length - 1))?_c('v-divider',{key:`v-div${local.id}`}):_vm._e()]})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }